import { ca } from '@cian/analytics';
import {
  IBaseProps,
  ITrackClickOnOfferButtonProps,
  ITrackFormValuesProps,
  ITrackFunctionParams,
  ITrackRedirectProps,
  ITrackShowMultiOffers,
  ITrackShowOffers,
} from './types';

const trackEvent = (props: ITrackFunctionParams) => {
  const { extra, deviceType, userId, ...params } = props;
  ca('eventSite', {
    ec: 'mortgage_main_landing_page',
    event: 'oldevent',
    ...params,
    user: {
      userId,
    },
    page: {
      pageType: 'mortgage_main_landing_page',
      siteType: /* istanbul ignore next */ deviceType === 'phone' ? 'mobile' : deviceType,
      extra: {
        ...(extra || {}),
      },
    },
  });
};

export const trackClickOnTargetButton = ({ deviceType, userId }: IBaseProps) => {
  trackEvent({
    ea: 'click',
    el: 'header_choose_mortgage_button',
    userId,
    deviceType,
  });
};

export const trackEditFormValues = ({ deviceType, userId, userInput }: ITrackFormValuesProps) => {
  trackEvent({
    ea: 'click',
    el: 'calculation_filter',
    userId,
    deviceType,
    extra: {
      userInput,
    },
  });
};

export const trackClickOnMoreFilters = ({ deviceType, userId }: IBaseProps) => {
  trackEvent({
    ea: 'click',
    el: 'more_filters',
    userId,
    deviceType,
  });
};

export const trackClickOnOfferButton = ({ deviceType, userId, offer }: ITrackClickOnOfferButtonProps) => {
  trackEvent({
    ea: 'click',
    el: 'pre_offer_choose',
    userId,
    deviceType,
    extra: {
      offer,
    },
  });
};

export const trackShowOffers = ({ deviceType, userId, offers }: ITrackShowOffers) => {
  trackEvent({
    ea: 'show',
    el: 'pre_offers',
    userId,
    deviceType,
    extra: {
      offers: {
        ...offers,
      },
    },
  });
};

export const trackShowMultiOffer = ({ deviceType, userId, offers, bank }: ITrackShowMultiOffers) => {
  trackEvent({
    ea: 'show',
    el: 'show_all_pre_offers_in_bank',
    userId,
    deviceType,
    extra: {
      bank,
      offers: {
        ...offers,
      },
    },
  });
};

export const trackClickOpenMultiOffer = ({ deviceType, userId }: IBaseProps) => {
  trackEvent({
    ea: 'click',
    el: 'show_all_pre_offers_in_bank',
    userId,
    deviceType,
  });
};

export const trackRedirect = ({ userId, deviceType, bank, type }: ITrackRedirectProps) => {
  trackEvent({
    ea: 'click',
    el: 'redirect',
    userId,
    deviceType,
    extra: {
      type,
      bank,
    },
  });
};

export const trackOpenPhoneAuthModal = ({ deviceType, userId }: IBaseProps) => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'show',
    el: 'phone',
    userId,
    deviceType,
  });
};

export const trackOpenSmsAuthModal = ({ deviceType, userId }: IBaseProps) => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'show',
    el: 'sms_code',
    userId,
    deviceType,
  });
};

export const trackClickConfirmPhone = ({ deviceType, userId }: IBaseProps) => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'click',
    el: 'phone_continue',
    userId,
    deviceType,
  });
};

export const trackClickOnRepeatSms = ({ deviceType, userId }: IBaseProps) => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'click',
    el: 'phone_send_again',
    userId,
    deviceType,
  });
};

export const trackAgreeToCommercial = ({ deviceType, userId }: IBaseProps) => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'click',
    el: 'agree_on_ads',
    userId,
    deviceType,
  });
};

export const trackClickConfirmSms = ({ deviceType, userId }: IBaseProps) => {
  trackEvent({
    ec: 'AuthBlock',
    ea: 'click',
    el: 'sms_code_verify',
    userId,
    deviceType,
  });
};

export const trackAuthorizationSuccess = ({ deviceType, userId }: IBaseProps) => {
  trackEvent({
    ec: 'Authorization',
    ea: 'success',
    el: 'Auth_phone',
    userId,
    deviceType,
  });
};
